var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-save-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-save-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-save-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-save-head" }, [
                _c("h2", { attrs: { id: "wkb-save-title" } }, [
                  _vm._v("Save graph"),
                ]),
                _vm.completionMessage
                  ? _c(
                      "div",
                      {
                        staticClass: "wkb-subheader-callout",
                        attrs: { role: "status" },
                      },
                      [_vm._v(" " + _vm._s(_vm.completionMessage) + " ")]
                    )
                  : _c("p", { staticClass: "wkb-save-intro" }, [
                      _vm._v(" Store this graph in "),
                      _c("strong", [_vm._v("My library")]),
                      _vm._v(
                        " (this browser) so you can reload it without rebuilding from scratch. "
                      ),
                    ]),
              ]),
              !_vm.completionMessage
                ? _c(
                    "p",
                    { staticClass: "wkb-save-note", attrs: { role: "note" } },
                    [
                      _vm._v(
                        " My library saves the graph layout and links only. Inspector results are not stored and will not reload from My library. Use "
                      ),
                      _c("strong", [_vm._v("Manage → Export graph")]),
                      _vm._v(
                        " to keep inspection data for rebuilding this workflow later. "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "label",
                {
                  staticClass: "wkb-save-label",
                  attrs: { for: "wkb-save-name" },
                },
                [_vm._v("Graph name")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localLabel,
                    expression: "localLabel",
                  },
                ],
                ref: "nameInput",
                staticClass: "wkb-save-input",
                attrs: {
                  id: "wkb-save-name",
                  type: "text",
                  maxlength: "120",
                  placeholder: "Untitled graph",
                },
                domProps: { value: _vm.localLabel },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                    return _vm.onSave.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.localLabel = $event.target.value
                  },
                },
              }),
              _vm.summary
                ? _c("p", { staticClass: "wkb-save-summary" }, [
                    _vm._v(_vm._s(_vm.summary)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "wkb-save-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-save-btn wkb-save-btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-save-btn wkb-save-btn-primary",
                    attrs: { type: "button", disabled: !_vm.canSave },
                    on: { click: _vm.onSave },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isUpdate ? "Update in library" : "Save to library"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }